import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import APIService from '../services/APIService';
import { useUser, useAccessToken } from '@features/user';

const CheckoutCancel: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sessionData, setSessionData] = useState<any>(null);

  const user = useUser();
  const { getAccessToken } = useAccessToken();

  useEffect(() => {
    const fetchSessionData = async () => {
      const searchParams = new URLSearchParams(location.search);
      const sessionId = searchParams.get('session_id');

      if (sessionId) {
        try {
          const accessToken = await getAccessToken();
          const response = await APIService.makeAPIGetRequest({
            requestString: `/user/getCheckoutSession?session_id=${sessionId}`,
            accessToken: accessToken,
          });

          if (response.ok) {
            setSessionData(response.value.session);
            console.log('Checkout session data:', response.value.session);
          } else {
            console.error('Failed to retrieve checkout session data:', response);
          }
        } catch (error) {
          console.error('Error fetching checkout session data:', error);
        }
      }
    };

    fetchSessionData();
  }, [location.search]);

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Box sx={{ backgroundColor: '#f4f6f8', minHeight: '100vh', pt: 4 }}>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh" }}>
        <Paper
          sx={{
            p: 4,
            width: '500px',
            borderRadius: '10px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
          }}
        >
          <CancelIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: '#3f51b5' }}>
            Checkout Canceled
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, color: 'textSecondary' }}>
            Your checkout process has been canceled. No charges have been made.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleGoToDashboard}
            sx={{
              textTransform: 'none',
              borderRadius: '25px',
              px: 4,
              minWidth: '200px',
            }}
          >
            Return to Dashboard
          </Button>
        </Paper>
      </Box>
    </Box>
  );
};

export default CheckoutCancel;
